<mat-sidenav-container fullscreen>
  @if ((user$ | async)?.signed) {
    <mat-sidenav class="mat-elevation-z2" #sidenav mode="over">
      <mat-toolbar class="px-1">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col px-1 mat-headline-4 m-0 font-weight-light text-center">
              <img width="130" src="assets/img/ranvou/logoletras.png" alt="Ranvou" />
            </div>
          </div>
        </div>
      </mat-toolbar>
      <mat-divider></mat-divider>
      <!--Menu-->
      <div class="container-fluid">
        <!--menu-->
        <div
          class="row py-1 app-menu"
          role="button"
          tabindex="0"
          (click)="onNavigate(['/obras'], $event)"
          (keydown.enter)="onNavigate(['/obras'], $event)"
          (keydown.space)="onNavigate(['/obras'], $event)">
          <div class="col px-0">
            <!--opcion-->
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-auto ps-2 pe-1">
                  <mat-icon class="mt-1 mx-1 icon-sm">construction</mat-icon>
                </div>
                <div class="col px-0 text-start">
                  <span class="mat-body">Obras</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--menu-->
        <div
          class="row py-1 app-menu"
          role="button"
          tabindex="0"
          (click)="onSubMenu('usuarios')"
          (keydown.enter)="onSubMenu('usuarios')"
          (keydown.space)="onSubMenu('usuarios')">
          <div class="col px-0">
            <!--opcion-->
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-auto ps-2 pe-1">
                  <mat-icon class="mt-1 mx-1 icon-sm">engineering</mat-icon>
                </div>
                <div class="col px-0 text-start">
                  <span class="mat-body">Usuarios</span>
                </div>
                @if (submenu === 'usuarios') {
                  <div class="col px-0 text-end">
                    <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_down</mat-icon>
                  </div>
                }
                @if (submenu !== 'usuarios') {
                  <div class="col px-0 text-end">
                    <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_right</mat-icon>
                  </div>
                }
              </div>
              @if (esMaster) {
                <div
                  [hidden]="!(submenu === 'usuarios')"
                  class="row py-1 app-menu align-items-center"
                  role="button"
                  tabindex="0"
                  (click)="onNavigate(['/usuarios/base-de-datos'], $event)"
                  (keydown.enter)="onNavigate(['/usuarios/base-de-datos'], $event)"
                  (keydown.space)="onNavigate(['/usuarios/base-de-datos'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Base de Datos</span>
                  </div>
                </div>
              }
              <div
                [hidden]="!(submenu === 'usuarios')"
                class="row py-1 app-menu align-items-center"
                role="button"
                tabindex="0"
                (click)="onNavigate(['/usuarios/en-obras'], $event)"
                (keydown.enter)="onNavigate(['/usuarios/en-obras'], $event)"
                (keydown.space)="onNavigate(['/usuarios/en-obras'], $event)">
                <div class="col-auto ps-4 pe-2 text-start">
                  <span class="mat-caption">En Obras</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--menu-->
        <div class="row py-1 app-menu" (click)="onNavigate(['/archivos-idse'], $event)" role="button" tabindex="0" (keydown.enter)="onNavigate(['/archivos-idse'], $event)" (keydown.space)="onNavigate(['/archivos-idse'], $event)">
          <div class="col px-0">
            <!--opcion-->
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-auto ps-2 pe-1">
                  <mat-icon class="mt-1 mx-1 icon-sm">description</mat-icon>
                </div>
                <div class="col px-0 text-start">
                  <span class="mat-body">IDSE</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--menu-->
        @if (esMaster && false) {
          <div class="row py-1 app-menu" (click)="onNavigate(['/dashboard/master'], $event)" role="button" tabindex="0" (keydown.enter)="onNavigate(['/dashboard/master'], $event)" (keydown.space)="onNavigate(['/dashboard/master'], $event)">
            <div class="col px-0">
              <!--opcion-->
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-auto ps-2 pe-1">
                    <mat-icon class="mt-1 mx-1 icon-sm">dashboard</mat-icon>
                  </div>
                  <div class="col px-0 text-start">
                    <span class="mat-body">Dashboard</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!--menu-->
        @if (!esMaster && false) {
          <div class="row py-1 app-menu" (click)="onNavigate(['/dashboard/empresa'], $event)" role="button" tabindex="0" (keydown.enter)="onNavigate(['/dashboard/empresa'], $event)" (keydown.space)="onNavigate(['/dashboard/empresa'], $event)">
            <div class="col px-0">
              <!--opcion-->
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-auto ps-2 pe-1">
                    <mat-icon class="mt-1 mx-1 icon-sm">dashboard</mat-icon>
                  </div>
                  <div class="col px-0 text-start">
                    <span class="mat-body">eDashboard</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!--EMPRESA-->
        <div class="row py-1 app-menu" (click)="onSubMenu('empresa')" role="button" tabindex="0" (keydown.enter)="onSubMenu('empresa')" (keydown.space)="onSubMenu('empresa')">
          <div class="col px-0">
            <!--opcion-->
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-auto ps-2 pe-1">
                  <mat-icon class="mt-1 mx-1 icon-sm">apartment</mat-icon>
                </div>
                <div class="col px-0 text-start">
                  <span class="mat-body">Empresa</span>
                </div>
                @if (submenu === 'empresa') {
                  <div class="col px-0 text-end">
                    <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_down</mat-icon>
                  </div>
                }
                @if (submenu !== 'empresa') {
                  <div class="col px-0 text-end">
                    <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_right</mat-icon>
                  </div>
                }
              </div>
              <div
                [hidden]="!(submenu === 'empresa')"
                (click)="onNavigate(['/configuracion-empresa/datos-empresa'], $event)"
                class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/configuracion-empresa/datos-empresa'], $event)" (keydown.space)="onNavigate(['/configuracion-empresa/datos-empresa'], $event)">
                <div class="col-auto ps-4 pe-2 text-start">
                  <span class="mat-caption">Datos Empresa</span>
                </div>
              </div>
              <div
                [hidden]="!(submenu === 'empresa')"
                (click)="onNavigate(['/configuracion-empresa/empleados-fijos'], $event)"
                class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/configuracion-empresa/empleados-fijos'], $event)" (keydown.space)="onNavigate(['/configuracion-empresa/empleados-fijos'], $event)">
                <div class="col-auto ps-4 pe-2 text-start">
                  <span class="mat-caption">Empleados Fijos</span>
                </div>
              </div>
              <div
                [hidden]="!(submenu === 'empresa')"
                (click)="onNavigate(['/configuracion-empresa/administradores-web'], $event)"
                class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/configuracion-empresa/administradores-web'], $event)" (keydown.space)="onNavigate(['/configuracion-empresa/administradores-web'], $event)">
                <div class="col-auto ps-4 pe-2 text-start">
                  <span class="mat-caption">Administradores Web</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--INSUMOS-->
        @if (esMaster) {
          <div class="row py-1 app-menu" (click)="onSubMenu('insumos')" role="button" tabindex="0" (keydown.enter)="onSubMenu('insumos')" (keydown.space)="onSubMenu('insumos')">
            <div class="col px-0">
              <!--opcion-->
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-auto ps-2 pe-1">
                    <mat-icon class="mt-1 mx-1 icon-sm">landslide</mat-icon>
                  </div>
                  <div class="col px-0 text-start">
                    <span class="mat-body">Insumos</span>
                  </div>
                  @if (submenu === 'insumos') {
                    <div class="col px-0 text-end">
                      <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_down</mat-icon>
                    </div>
                  }
                  @if (submenu !== 'insumos') {
                    <div class="col px-0 text-end">
                      <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_right</mat-icon>
                    </div>
                  }
                </div>
                <div
                  [hidden]="!(submenu === 'insumos')"
                  (click)="onNavigate(['/insumos/importar-excel'], $event)"
                  class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/insumos/importar-excel'], $event)" (keydown.space)="onNavigate(['/insumos/importar-excel'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Importar Insumos</span>
                  </div>
                </div>
                <div
                  [hidden]="!(submenu === 'insumos')"
                  (click)="onNavigate(['/insumos/ver-conceptos-interes-maestra'], $event)"
                  class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/insumos/ver-conceptos-interes-maestra'], $event)" (keydown.space)="onNavigate(['/insumos/ver-conceptos-interes-maestra'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Conceptos que mostraron Interes</span>
                  </div>
                </div>
                <div
                  [hidden]="!(submenu === 'insumos')"
                  (click)="onNavigate(['/insumos/catalogo-libre'], $event)"
                  class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/insumos/catalogo-libre'], $event)" (keydown.space)="onNavigate(['/insumos/catalogo-libre'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Catálogo de insumos</span>
                  </div>
                </div>
                <div
                  [hidden]="!(submenu === 'insumos')"
                  (click)="onNavigate(['/insumos/galeria-imagenes'], $event)"
                  class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/insumos/galeria-imagenes'], $event)" (keydown.space)="onNavigate(['/insumos/galeria-imagenes'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Galería de imágenes</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <!--CONFIGURACION-->
        <div class="row py-1 app-menu" (click)="onSubMenu('configuracion')" role="button" tabindex="0" (keydown.enter)="onSubMenu('configuracion')" (keydown.space)="onSubMenu('configuracion')">
          <div class="col px-0">
            <!--opcion-->
            <div class="container-fluid">
              <div class="row align-items-center">
                <div class="col-auto ps-2 pe-1">
                  <mat-icon class="mt-1 mx-1 icon-sm">settings</mat-icon>
                </div>
                <div class="col px-0 text-start">
                  <span class="mat-body">Configuración</span>
                </div>
                @if (submenu === 'configuracion') {
                  <div class="col px-0 text-end">
                    <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_down</mat-icon>
                  </div>
                }
                @if (submenu !== 'configuracion') {
                  <div class="col px-0 text-end">
                    <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_right</mat-icon>
                  </div>
                }
              </div>
              @if (esMaster) {
                <div
                  [hidden]="!(submenu === 'configuracion')"
                  (click)="onNavigate(['/configuracion-empresa/plantillas-contratos'], $event)"
                  class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/configuracion-empresa/plantillas-contratos'], $event)" (keydown.space)="onNavigate(['/configuracion-empresa/plantillas-contratos'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Plantillas de Contratos</span>
                  </div>
                </div>
              }
              <div
                [hidden]="!(submenu === 'configuracion')"
                (click)="onNavigate(['/configuracion-empresa/contratos'], $event)"
                class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/configuracion-empresa/contratos'], $event)" (keydown.space)="onNavigate(['/configuracion-empresa/contratos'], $event)">
                <div class="col-auto ps-4 pe-2 text-start">
                  <span class="mat-caption">Contratos</span>
                </div>
              </div>
              <div
                [hidden]="!(submenu === 'configuracion')"
                (click)="onNavigate(['/catalogos/etiquetas-contratos'], $event)"
                class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/catalogos/etiquetas-contratos'], $event)" (keydown.space)="onNavigate(['/catalogos/etiquetas-contratos'], $event)">
                <div class="col-auto ps-4 pe-2 text-start">
                  <span class="mat-caption">Etiquetas Contratos</span>
                </div>
              </div>
              <div
                [hidden]="!(submenu === 'configuracion')"
                (click)="onNavigate(['/configuracion-empresa/aviso-de-privacidad'], $event)"
                class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/configuracion-empresa/aviso-de-privacidad'], $event)" (keydown.space)="onNavigate(['/configuracion-empresa/aviso-de-privacidad'], $event)">
                <div class="col-auto ps-4 pe-2 text-start">
                  <span class="mat-caption">Aviso de Privacidad</span>
                </div>
              </div>
              @if (esMaster) {
                <div
                  [hidden]="!(submenu === 'configuracion')"
                  (click)="onNavigate(['/configuracion-empresa/terminos-de-uso'], $event)"
                  class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/configuracion-empresa/terminos-de-uso'], $event)" (keydown.space)="onNavigate(['/configuracion-empresa/terminos-de-uso'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Terminos de Uso</span>
                  </div>
                </div>
              }
              @if (esMaster) {
                <div
                  [hidden]="!(submenu === 'configuracion')"
                  (click)="onNavigate(['/calculo-salario-real/configuracion'], $event)"
                  class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/calculo-salario-real/configuracion'], $event)" (keydown.space)="onNavigate(['/calculo-salario-real/configuracion'], $event)">
                  <div class="col-auto ps-4 pe-2 text-start">
                    <span class="mat-caption">Integracion SBC Global</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <!--CATALOGOS-->
        @if (esMaster && false) {
          <div class="row py-1 app-menu" (click)="onSubMenu('catalogos')" role="button" tabindex="0" (keydown.enter)="onSubMenu('catalogos')" (keydown.space)="onSubMenu('catalogos')">
            <div class="col px-0">
              <!--opcion-->
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-auto ps-2 pe-1">
                    <mat-icon class="mt-1 mx-1 icon-sm">menu_book</mat-icon>
                  </div>
                  <div class="col px-0 text-start">
                    <span class="mat-body">Catalogos</span>
                  </div>
                  @if (submenu === 'catalogos') {
                    <div class="col px-0 text-end">
                      <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_down</mat-icon>
                    </div>
                  }
                  @if (submenu !== 'catalogos') {
                    <div class="col px-0 text-end">
                      <mat-icon class="mt-2 mx-1 icon-sm">keyboard_arrow_right</mat-icon>
                    </div>
                  }
                </div>
                @if (esMaster && false) {
                  <div
                    [hidden]="!(submenu === 'catalogos')"
                    (click)="onNavigate(['/catalogos/categorias'], $event)"
                    class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/catalogos/categorias'], $event)" (keydown.space)="onNavigate(['/catalogos/categorias'], $event)">
                    <div class="col-auto ps-4 pe-2 text-start">
                      <span class="mat-caption">Categorías</span>
                    </div>
                  </div>
                }
                @if (esMaster && false) {
                  <div
                    [hidden]="!(submenu === 'catalogos')"
                    (click)="onNavigate(['/catalogos/subcategorias'], $event)"
                    class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/catalogos/subcategorias'], $event)" (keydown.space)="onNavigate(['/catalogos/subcategorias'], $event)">
                    <div class="col-auto ps-4 pe-2 text-start">
                      <span class="mat-caption">Sub Categorías</span>
                    </div>
                  </div>
                }
                @if (esMaster && false) {
                  <div
                    [hidden]="!(submenu === 'catalogos')"
                    (click)="onNavigate(['/catalogos/caracteristicas'], $event)"
                    class="row py-1 app-menu align-items-center" role="button" tabindex="0" (keydown.enter)="onNavigate(['/catalogos/caracteristicas'], $event)" (keydown.space)="onNavigate(['/catalogos/caracteristicas'], $event)">
                    <div class="col-auto ps-4 pe-2 text-start">
                      <span class="mat-caption">Caracteristicas</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <div class="row py-1">
          <div class="col">
            <p class="text-end mat-caption text-muted">
              {{ appVersion }}{{ environment }}
              <br />
              {{ projectId }}
            </p>
          </div>
        </div>
      </div>
    </mat-sidenav>
  }
  <mat-sidenav-content>
    <!--Toolbar-->
    @if (user$ | async; as sesion) {
      <mat-toolbar
        class="bc-gray border-bottom animate__animated animate__fast animate__fadeIn"
        >
        @if (sesion) {
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-auto p-0 text-start" style="height: 24px">
                <mat-icon
                  class="me-2"
                  (mouseenter)="sidenav.opened ? sidenav.close() : sidenav.open()"
                fontIcon="menu"></mat-icon>
              </div>
              <div class="col-auto p-0 text-start">
                @if (!esMaster) {
                  <span class="mat-body">
                    @if (empresaSelGlobal$ | async; as empresa) {
                      <span class="mat-body">
                        {{ empresa?.nombre }}
                      </span>
                    }
                  </span>
                }
                <div class="d-flex align-items-center">
                  @if (esMaster) {
                    <mat-form-field class="p-0 opacity-0" style="z-index: -1">
                      <mat-select [panelWidth]="null" (selectionChange)="onSelectEmpresa($event)" #selectEmpresas>
                        @for (empresa of empresas; track empresa) {
                          <mat-option
                            [ngClass]="{ 'c-orange': sesion.empresa.id === empresa.id }"
                            [value]="empresa">
                            {{ empresa.nombre }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (esMaster) {
                    <button class="px-1 position-absolute" (click)="onEmpresas()" mat-button>
                      @if (empresaSelGlobal$ | async; as empresa) {
                        <span [ngClass]="{ 'c-orange': sesion.empresa.id === empresa.id }" class="mat-body">
                          {{ empresa?.nombre }}
                        </span>
                      }
                      @if (empresaSelGlobal$ | async; as empresa) {
                        <mat-icon
                          style="padding-top: 7px; padding-left: 7px"
                          [ngClass]="{ 'c-orange': sesion.empresa.id === empresa.id }">
                          arrow_drop_down
                        </mat-icon>
                      }
                    </button>
                  }
                </div>
              </div>
              <div class="col-sm-auto ms-auto col p-0 text-end">
                <div class="d-flex align-items-center">
                  <span class="mat-body align-self-center">{{ sesion?.data?.displayName }} {{ sesion?.data?.email }}</span>
                  <div
                    matRipple
                    [matMenuTriggerFor]="currentUserMenu"
                    class="mx-2 c-pointer bg-img-45 rounded-circle"
                [ngStyle]="{
                  background:
                    'url(' + (sesion?.usuario?.imgPerfilURL | imageSize : '100') + '), url(./assets/img/user-ph-50.jpg)'
                }"></div>
                  <mat-menu #currentUserMenu="matMenu">
                    @if (false) {
                      <button mat-menu-item>
                        <mat-icon>settings</mat-icon>
                        <span>Perfil</span>
                      </button>
                    }
                    <div class="d-block d-sm-none col pb-1">
                      <span class="mat-body">{{ sesion?.data?.displayName }} {{ sesion?.data?.email }}</span>
                    </div>
                    <!-- <button (click)="onCerrarSesion()" mat-menu-item>
                    <mat-icon>person</mat-icon>
                    <span>Mi Perfil</span>
                  </button> -->
                  <button (click)="onCerrarSesion()" mat-menu-item>
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Cerrar Sesión</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </div>
      }
    </mat-toolbar>
  }

  <!-- Alerts -->
  @if (user$ | async; as sesion) {
    @if (sesion.signed && !sesion.usuario.emailConfirmado && !avisoCerrado) {
      <div class="alert alert-danger d-flex justify-content-between align-items-start flex-wrap">
        <div class="pt-2 pe-3">
          <p class="mb-2">
            No se ha confirmado su direccíon de correo. ({{ sesion.usuario.email }}) Por favor revise su bandeja de
            entrada para confirmarlo.
          </p>
          <div class="d-flex flex-wrap align-items-center gap-2">
            <button
              type="button"
              mat-stroked-button
              color="primary"
              class="py-1"
              [disabled]="resendEmailInFlight || resendEmailCountdown > 0"
              (click)="onReenviarEmailConfirmacion(sesion)">
              @if (resendEmailInFlight) {
                <span>Enviando...</span>
              }
              @if (!resendEmailInFlight) {
                <span>Reenviar correo de activación</span>
              }
            </button>
            @if (resendEmailCountdown > 0) {
              <span class="mat-caption text-muted">
                Podrás solicitarlo de nuevo en {{ resendEmailCountdown }}s
              </span>
            }
          </div>
        </div>
        <button type="button" mat-icon-button (click)="avisoCerrado = true">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  }

  <!--content-->
  @if (user$ | async; as usuarioActivo) {
    <div>
      <ng-content class="bg-light"></ng-content>
    </div>
  } @else {
    <div class="container h-100 bg-light">
      <div class="row h-100 justify-content-center text-center align-items-center">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    </div>
  }
</mat-sidenav-content>
</mat-sidenav-container>
